import React from "react";
import { CategoryStyleType } from "../../../models/base/CategoryStyleType";

interface Item {
    id: string;
    name: string;
    slug: string;
    order: number;
}

interface CategoryTypesProps {
    style?: CategoryStyleType;
    primaryColor?: string;
    secondaryColor?: string;
    items?: Item[];
    selectedItemId?: string;
    onItemSelect?: (itemId: string) => void;
}

const CategoryTypes: React.FC<CategoryTypesProps> = ({ style, primaryColor, secondaryColor, items = [], selectedItemId, onItemSelect }) => {

    const handleItemClick = (itemId: string) => {
        if (onItemSelect) {
            onItemSelect(itemId);
        }
    };

    if (style === CategoryStyleType.Style_1) {
        return (
            <section className="client-category-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="client-category-wrapper">
                        <div className="client-category-list-div">

                            {items
                                .sort((a, b) => a.order - b.order)
                                .map(item => {
                                    const isSelected = selectedItemId === item.id;
                                    return (
                                        <div
                                            key={item.id}
                                            className={`client-category-div ${isSelected ? "select" : ""}`}
                                            style={
                                                isSelected
                                                    ? { borderColor: primaryColor, color: primaryColor }
                                                    : { color: primaryColor, opacity: 0.6 }
                                            }
                                            onClick={() => handleItemClick(item.id)}
                                        >
                                            <div className="client-category-name">{item.name}</div>
                                        </div>
                                    );
                                })}

                        </div>
                    </div>
                </div>
            </section>
        )
    }
    else if (style === CategoryStyleType.Style_2) {
        return (
            <section className="client-category-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="client-category-wrapper">
                        <div className="client-category-list-div">

                            {items
                                .sort((a, b) => a.order - b.order)
                                .map(item => {
                                    const isSelected = selectedItemId === item.id;
                                    return (
                                        <div
                                            key={item.id}
                                            className={`client-category-div style-2 ${isSelected ? "select" : ""}`}
                                            style={
                                                isSelected
                                                    ? { background: primaryColor }
                                                    : { color: primaryColor, opacity: 0.6 }
                                            }
                                            onClick={() => handleItemClick(item.id)}
                                        >
                                            <div className="client-category-name">{item.name}</div>
                                        </div>
                                    );
                                })}

                        </div>
                    </div>
                </div>
            </section>
        )
    } else if (style === CategoryStyleType.Style_2_1) {
        return (
            <section className="client-category-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="client-category-wrapper">
                        <div className="client-category-list-div">

                            {items
                                .sort((a, b) => a.order - b.order)
                                .map(item => {
                                    const isSelected = selectedItemId === item.id;
                                    return (
                                        <div
                                            key={item.id}
                                            className={`client-category-div style-2 style2-1 ${isSelected ? "select" : ""}`}
                                            style={
                                                isSelected
                                                    ? { background: primaryColor }
                                                    : { color: primaryColor, opacity: 0.6 }
                                            }
                                            onClick={() => handleItemClick(item.id)}
                                        >
                                            <div className="client-category-name">{item.name}</div>
                                        </div>
                                    );
                                })}

                        </div>
                    </div>
                </div>
            </section>
        )
    } else if (style === CategoryStyleType.Style_2_2) {
        return (
            <section className="client-category-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="client-category-wrapper">
                        <div className="client-category-list-div">

                            {items
                                .sort((a, b) => a.order - b.order)
                                .map(item => {
                                    const isSelected = selectedItemId === item.id;
                                    return (
                                        <div
                                            key={item.id}
                                            className={`client-category-div style-2 style2-2 ${isSelected ? "select" : ""}`}
                                            style={
                                                isSelected
                                                    ? { background: primaryColor }
                                                    : { color: primaryColor, opacity: 0.6 }
                                            }
                                            onClick={() => handleItemClick(item.id)}
                                        >
                                            <div className="client-category-name">{item.name}</div>
                                        </div>
                                    );
                                })}

                        </div>
                    </div>
                </div>
            </section>
        )
    } else if (style === CategoryStyleType.Style_3) {
        return (
            <section className="client-category-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="client-category-wrapper">
                        <div className="client-category-list-div">

                            {items
                                .sort((a, b) => a.order - b.order)
                                .map(item => {
                                    const isSelected = selectedItemId === item.id;
                                    return (
                                        <div
                                            key={item.id}
                                            className={`client-category-div style-3 ${isSelected ? "select" : ""}`}
                                            style={
                                                isSelected
                                                    ? { background: "white", color: primaryColor }
                                                    : { color: primaryColor, opacity: 0.6 }
                                            }
                                            onClick={() => handleItemClick(item.id)}
                                        >
                                            <div className="client-category-name">{item.name}</div>
                                        </div>
                                    );
                                })}

                        </div>
                    </div>
                </div>
            </section>
        )
    } else {
        return (
            <section className="client-category-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="client-category-wrapper">
                        <div className="client-category-list-div">

                            {items
                                .sort((a, b) => a.order - b.order)
                                .map(item => {
                                    const isSelected = selectedItemId === item.id;
                                    return (
                                        <div
                                            key={item.id}
                                            className={`client-category-div style-2 style2-2 ${isSelected ? "select" : ""}`}
                                            style={
                                                isSelected
                                                    ? { background: primaryColor }
                                                    : { color: primaryColor, opacity: 0.6 }
                                            }
                                            onClick={() => handleItemClick(item.id)}
                                        >
                                            <div className="client-category-name">{item.name}</div>
                                        </div>
                                    );
                                })}

                        </div>
                    </div>
                </div>
            </section>
        )
    };
};

export default CategoryTypes;